import { render, staticRenderFns } from "./ProfileInvoices.vue?vue&type=template&id=0a7df2b4&scoped=true&"
import script from "./ProfileInvoices.vue?vue&type=script&lang=ts&"
export * from "./ProfileInvoices.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileInvoices.vue?vue&type=style&index=0&id=0a7df2b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7df2b4",
  null
  
)

export default component.exports